import type { IDocument } from "@bbj-types/document";
import type { ISms } from "@bbj-types/message";
import type { INotification } from "@bbj-types/notification";
import type { SmsSentStatus } from "@root/utils/enums/communication";

export enum WebsocketChannelEventActions {
  NEW_SMS = "user:sms:new",
  NEW_HIRED_CANDIDATE = "candidate:hired:new",
}

export enum WebsocketChannelCandidateActions {
  ISOCHRONES = "update:isochrones",
}

export enum WebsocketChannelDocumentActions {
  UPLOADED = "update:uploaded",
}

export enum WebsocketChannelNotificationActions {
  NEW_NOTIFICATION = "notification:new",
}

export enum WebsocketUpdateSMSStatusActions {
  SMS_STATUS_UPDATE = "update:status",
}

export interface IWebsocketUpdateSMSStatusBody {
  smsId: string;
  status: SmsSentStatus;
}

export enum WebsocketChannels {
  EVENT = "event",
  CANDIDATE = "candidate",
  DOCUMENT = "document",
  NOTIFICATION = "notification",
  SMS_STATUS_UPDATE = "smsStatusUpdate",
}

export type IWebsocketBodyEvent =
  | {
      action: WebsocketChannelEventActions.NEW_HIRED_CANDIDATE;
      message: string;
      channel: WebsocketChannels.EVENT;
    }
  | {
      action: WebsocketChannelEventActions.NEW_SMS;
      message: ISms;
      channel: WebsocketChannels.EVENT;
    };

export type IWebsocketBodyCandidate = {
  action: WebsocketChannelCandidateActions.ISOCHRONES;
  message: undefined;
  channel: WebsocketChannels.CANDIDATE;
};

export type IWebsocketBodyDocument = {
  action: WebsocketChannelDocumentActions.UPLOADED;
  message: IDocument;
  channel: WebsocketChannels.DOCUMENT;
};

export type IWebsocketBodyNotification = {
  action: WebsocketChannelNotificationActions.NEW_NOTIFICATION;
  message: INotification;
  channel: WebsocketChannels.NOTIFICATION;
};

export type IWebsocketBodySMSStatusUpdate = {
  action: WebsocketUpdateSMSStatusActions;
  message: IWebsocketUpdateSMSStatusBody;
  channel: WebsocketChannels.SMS_STATUS_UPDATE;
};

export type IWebsocketBody =
  | IWebsocketBodyEvent
  | IWebsocketBodyCandidate
  | IWebsocketBodyDocument
  | IWebsocketBodyNotification
  | IWebsocketBodySMSStatusUpdate;
